<div class="button-group--container">
  <div class="buttons--container" [class.side]="orientation === 'side'" [class.top]="orientation === 'top'">
    <ng-content></ng-content>
  </div>
  <div *ngIf="errorMessage" class="error-message--container">{{ errorMessage }}</div>
</div>
